/**
 * Created by Andrey Popov on 13.04.2026
 */

const isInMergeLocation = function () {
    const location = cleverapps.meta && cleverapps.meta.getSelectedLocation();
    return location && location.locationConfig && location.locationConfig.locationType === "merge";
};

if (!["merge", "merge2", "farm"].includes(cleverapps.config.type)) {
    RewardTypes.exp.parse = function (value, options) {
        return isInMergeLocation() ? [] : [new Reward("exp", value, options)];
    };

    FogBlock.prototype.giftBubbles = function () {
        new RewardsList({ units: this.getBubbles() }, { toMainWorld: true }).receiveRewards();
    };
}

if (["riddles"].includes(cleverapps.config.name)) {
    const HARD_MATCH3_PER_HARD_MERGE = 2.3;
    const SOFT_TO_HARD = 0.5;

    const toHardMatch3 = function (hardMergeValue) {
        if (!hardMergeValue) {
            return 0;
        }
        return toHardMatch3.round(Math.max(1, Math.ceil(hardMergeValue * HARD_MATCH3_PER_HARD_MERGE)));
    };

    toHardMatch3.round = function (value) {
        if (value >= 100) {
            return Math.round(value / 10) * 10;
        }
        if (value >= 10) {
            return Math.round(value / 5) * 5;
        }
        return value;
    };

    const TREASURE_BOOSTERS = {
        0: { id: cleverapps.Boosters.TYPE_CELL, amount: 2 },
        1: { id: cleverapps.Boosters.TYPE_LINE, amount: 2 },
        2: { id: cleverapps.Boosters.TYPE_COLOR, amount: 3 }
    };

    const CRYSTAL_BOOSTERS = {
        1: { id: cleverapps.Boosters.TYPE_COMBO, amount: 1 },
        2: { id: cleverapps.Boosters.TYPE_MOVES, amount: 1 },
        3: { id: cleverapps.Boosters.TYPE_MULTICOLOR, amount: 2 }
    };

    const softToHardMatch3 = function (soft) {
        return toHardMatch3.round(Math.max(1, Math.ceil(soft * SOFT_TO_HARD)));
    };

    const getUnitHardPrize = function (u) {
        const unit = Families[u.code] && Families[u.code].units && Families[u.code].units[u.stage];
        if (!unit || !unit.mineable) {
            return 0;
        }
        for (const task of unit.mineable.tasks || []) {
            const prize = cleverapps.toArray(task.prizes).find((p) => p.resource === "hard");
            if (prize) {
                return toHardMatch3(prize.amount);
            }
        }
        return 0;
    };

    const convertUnit = function (u) {
        const booster = u.code === "treasure" && TREASURE_BOOSTERS[u.stage]
            || u.code === "crystal" && CRYSTAL_BOOSTERS[u.stage];
        if (booster) {
            return { type: "boosters", value: { id: booster.id, amount: booster.amount * (u.amount || 1) } };
        }
        const hardPrize = getUnitHardPrize(u);
        if (hardPrize) {
            return { type: "hard", value: hardPrize };
        }
        const family = Families[u.code];
        const hardPrice = family && family.price && family.price[u.stage];
        if (hardPrice) {
            return { type: "hard", value: toHardMatch3(hardPrice) };
        }
        const softAmount = family && family.amounts && family.amounts[u.stage];
        if (softAmount) {
            return { type: "hard", value: softToHardMatch3(softAmount) };
        }
        return { type: "hard", value: 1 };
    };

    RewardTypes.soft.parse = function (value, options) {
        return [new Reward("hard", softToHardMatch3(value), options)];
    };

    const _addReward = Map2dLocation.prototype.addReward;
    Map2dLocation.prototype.addReward = function (type, amount, source, options) {
        if (type === "soft") {
            type = "hard";
            amount = softToHardMatch3(amount);
        }
        if (type === "exp" && isInMergeLocation()) {
            return;
        }
        return _addReward.call(this, type, amount, source, options);
    };

    const _unitsParse = RewardTypes.units.parse;
    RewardTypes.units.parse = function (value, options) {
        if (options && options.toMainWorld) {
            return cleverapps.toArray(value).map((u) => {
                const converted = convertUnit(u);
                return new Reward(converted.type, converted.value, options);
            });
        }
        return _unitsParse.call(this, value, options);
    };

    const _unitsReceive = RewardTypes.units.receive;
    RewardTypes.units.receive = function (value) {
        if (this.options && this.options.toMainWorld) {
            const converted = convertUnit(value);
            return RewardTypes[converted.type].receive.call(this, converted.value, this.options);
        }
        return _unitsReceive.call(this, value);
    };

    RewardTypes.worker.parse = function (value, options) {
        return [new Reward("unlimitedLives", cleverapps.parseInterval(value) / 24, options)];
    };

    const _sortRewards = RewardsList.prototype.sortRewards;
    RewardsList.prototype.sortRewards = function () {
        const byType = {};
        this.rewards = this.rewards.filter((reward) => {
            if (typeof reward.value !== "number") {
                return true;
            }
            const merged = byType[reward.type];
            if (merged) {
                merged.value += reward.value;
                if (merged.type === "hard") {
                    merged.value = toHardMatch3.round(merged.value);
                }
                return false;
            }
            byType[reward.type] = reward;
            return true;
        });
        return _sortRewards.call(this);
    };

    FogBlock.prototype.convertHardPrice = function (price) {
        if (!this.isMoney()) {
            return price;
        }
        const ISLAND_USD_STEPS = [1, 2, 5, 10, 15, 20, 30, 45];
        const usd = price / 100;
        const snapped = ISLAND_USD_STEPS.reduce((best, step) => (Math.abs(step - usd) < Math.abs(best - usd) ? step : best));
        return toHardMatch3(snapped * 100) - 1;
    };

    const _needCollectConfirmation = Collectible.prototype.needCollectConfirmation;
    Collectible.prototype.needCollectConfirmation = function () {
        if (this.unit.code === "coins") {
            return false;
        }
        return _needCollectConfirmation.call(this);
    };

    const _getValue = Collectible.prototype.getValue;
    Collectible.prototype.getValue = function () {
        const value = _getValue.call(this);
        return this.unit.code === "coins" ? softToHardMatch3(value) : value;
    };

    const _collect = Collectible.prototype.collect;
    Collectible.prototype.collect = function (target, index) {
        if (this.unit.code === "coins" && this.unit.getData().collectible && !this.unit.getData().collectible.harvested) {
            this.unit.getData().collectible = { rewardType: "hard" };
        }
        return _collect.call(this, target, index);
    };

    Unit.convertHardPrice = toHardMatch3;

    CustomerRecipe.prototype.convertIngredientHardPrice = toHardMatch3;

    DynamiteToolbarItem.PRICE = toHardMatch3(DynamiteToolbarItem.PRICE);

    Unit.CalcSellCurrency = function () {
        return "hard";
    };

    MergeLocation.REWARDS = {
        fog1: {
            hard: 5
        },
        fog6: {
            hard: 5,
            unlimitedLives: "3 hours"
        },
        fog16: {
            hard: 10,
            unlimitedLives: "5 hours"
        },
        fog26: {
            hard: 15,
            unlimitedLives: "8 hours"
        },
        fog36: {
            hard: 25,
            unlimitedLives: "12 hours"
        }
    };
}
